// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__SU78R","label":"CategoryService_label__2HRI2","location":"CategoryService_location__3X-Gm"};